import { Stack, Button, TextField, Autocomplete } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import styled from 'styled-components';
import Table from '../custom/Table';
import { TProductData, MyObject } from "../../Models/Inventory";
import useService from '../../hooks/useService';
import { InventoryContext } from "../../contexts/InventoryContext";
import { createOrUpdateStockRequest, getStockRequest } from "../../services/Inventory";
import { AuthContext } from "../../contexts/AuthContext";
import { GridColDef, GridRowSelectionModel, GridRowParams, GridRenderCellParams } from '@mui/x-data-grid';
import { NotificationContext } from "../../contexts/NotificationContext";
import { TColumn } from "../../Models/common";

const Container = styled.div`
  width: 1400px !important;
  padding: '0 10px';
`
const MetalImage = styled.img`
  object-fit: contain;
  max-width: 100px;
  max-height: 45px;
  border-radius: 4px;
  cursor: zoom-in;
  padding: 3px 0;
`
const DropdownRow = styled.div`
  width: 800px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
`

interface ModalProps {
    onClose: () => any;
}
interface DestinationId {
    value: string,
    label: string
}


const PRODUCTS_CONFIG : TColumn<TProductData>[] = [
    {
        field: "images",
        headerName: 'Image',
    },
    {
        field: "productName",
        headerName: 'Product Name',
    },
    {
        field: "metalType",
        headerName: 'Metal Type',
    },
    {
        field: "id",
        headerName: 'SKU Id',
    },
    {
        field: "fineWeight",
        headerName: 'Fine Weight (gm)'
    },
    {
        field: "dimensions",
        headerName: 'Dimension',
    },
    {
        field: "shape",
        headerName: 'Shape',
    },
    {
        field: "metalPurity",
        headerName: 'Purity',
    },
    {
        field: "requstQty",
        headerName: 'Request Quantity',
    },
]

const CreateStockModal = ({ onClose }: ModalProps) => {
    const { user } = useContext(AuthContext)
    const { businessUnits, products } = useContext(InventoryContext)
    const { execute } = useService()

    const [destinationID, setDestinationId] = useState<DestinationId>({ value: '', label: '' } as DestinationId)
    const [remarks, setRemarks] = useState<string>('')

    const [goldFineWeight, setGoldFineWeight] = useState<number>(0)
    const [silverFineWeight, setSilverFineWeight] = useState<number>(0)

    const [isGoldSlected, setIsGoldSlected] = useState<boolean>(false)
    const [isSilverSlected, setIsSilverSlected] = useState<boolean>(false)
    const [selectedMetal, setSelectedMetal] = useState<string>('')
    const { notify } = useContext(NotificationContext);



    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
    const [rows, setRows] = useState<TProductData[]>(products as TProductData[]);

    // show the products belongs to the perticular requested center
    // useEffect(()=>{
    //     const filteredProducts = products.filter(item => item.centerId.some(center => center?.center === destinationID?.value));
    //     setRows(filteredProducts)
    // },[destinationID])

    const handleQuantityTransfer = (e: any, params: GridRenderCellParams) => {
        console.log("params are--", params)
        let value = e.target.value
        if(Number(value) < 0) value = 0
    
        let updatedRows: TProductData[] = []
    
        rows.forEach((row: TProductData) => {
          if(params.row.id === row.id ) {
            row['requstQty'] = Number(value)
            updatedRows.push(row)
         } 
         else {
            updatedRows.push(row)
        }
        })
        console.log("updated rows==", updatedRows)
        setRows(updatedRows as TProductData[])
       }

    const getInventoryColumns = () => {
        let minWidth = 300

        return PRODUCTS_CONFIG.map(field => {
            const row: GridColDef = {
                field: field.field,
                headerName: field.headerName,
                minWidth,
                align: 'left',
                editable: false
            }
            switch (field.field) {
                case "images":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        let url = params.row.images.length > 0 ? params.row.images.sort((a: MyObject, b: MyObject) => Number(a.priority) - Number(b.priority))[0].image : ''
                        return url ? <MetalImage src={url} /> : <MetalImage src={'/assets/images/elementor-placeholder-image.webp'} />
                    }
                    break;
                case "productName":
                    row.minWidth = 550;
                    row.renderCell = params => {
                        return params.row.productName ? params.row.productName : "NA"
                    }
                    break;
                case "id":
                    row.minWidth = 200;
                    break;
                case "fineWeight":
                    row.minWidth = 150;
                    row.renderCell = params => {
                        return params.row.fineWeight ? params.row.fineWeight : "NA"
                    }
                    break;
                case "dimensions":
                    row.minWidth = 120;
                    row.renderCell = params => {
                        return params.row.dimensions ? params.row.dimensions : "NA"
                    }
                    break;
                case "shape":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.shape ? params.row.shape : "NA"
                    }
                    break;
                case "metalPurity":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.metalPurity ?? "NA"
                    }
                    break;
                case "metalType":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.metalType ? params.row.metalType=== "MTG"? "gold":"silver" : "NA"
                    }
                    break;
                case "requstQty":
                    row.minWidth = 170;
                    row.type = 'number';
                    row.headerAlign = 'left';
                    row.renderCell = params => {
                        return <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            value={params.row.requstQty=== 0 ? '': params.row.requestQty}
                            onChange={(e) => handleQuantityTransfer(e, params)}
                            // label={'Request Qty'}
                            type={'number'}
                            disabled={!rowSelectionModel.includes(params.row.id)}
                        />
                    }
                    break;
                default:
                    row.minWidth = 100
                    break;
            }
            return row;
        })
    }

    // eslint-disable-next-line array-callback-return
    const transferBusinessUnits = businessUnits?.filter((unit) => {   // filter out the requestor center ID
        if (unit.value !== user.centerId)
            return unit
    })

    const handleSelection = () => {
        let updatedRow: TProductData[] = []

        rows?.forEach((row: TProductData) => {
            row['isEditable'] = true
            updatedRow.push(row as TProductData)
        })
        setRows(updatedRow)
    };

    const clearPreviousRowDetails = () => {
        let updatedRows: TProductData[] = []

        rows.forEach((row: TProductData) => {
            row['requstQty'] = 0
            updatedRows.push(row as TProductData)
        })
        setRows(updatedRows as TProductData[])
        setGoldFineWeight(0 as number)
        setSilverFineWeight(0 as number)
    }

    const handleRowSelectionModel = (newRowSelectionModel: GridRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);

        if (newRowSelectionModel.length === 0) {
            clearPreviousRowDetails()
        }
    }

    const handleSubmit = async () => {
        const selectedRows = rows.filter((row) => {
            if (row.requstQty) return row
        })
        const Ids: any = []
        selectedRows.forEach((el) => {
            Ids.push({ skuId: el.id, quantity: el.requstQty })
        })
        let payload = {
            lineItems: Ids,
            businessUnit: destinationID.value,
            remarks,
        }
        console.log("payload is==========>>", payload)
        const { error } = await execute(() => createOrUpdateStockRequest(payload))
        if (!error) {
            notify('Stock Request Created Successfully!');
            await execute(() => getStockRequest({}))
            onClose()
            clearPreviousRowDetails()
        } else {
            notify(error.reason, 'error');
        }
    }

    useEffect(() => {
        handleSelection()
    }, [])

    let columns = getInventoryColumns()

    console.log({ rows });

    return (
        <Container>
            <DropdownRow>   
                <Autocomplete
                    disablePortal
                    defaultValue={destinationID}
                    value={destinationID}
                    id="id"
                    options={transferBusinessUnits}
                    onChange={(e, v) => {
                        setDestinationId(v as DestinationId)
                        setSelectedMetal('')
                        setIsGoldSlected(false)
                        setIsSilverSlected(false)
                    }}
                    sx={{ width: '100%' }}
                    renderInput={(params) => (
                        <TextField {...params} label="Search Destination ID" size="medium" />
                    )}
                />
            </DropdownRow>

            <Table
                editMode="row"
                rows={rows ?? []}
                getRowId={(row) => row.id}
                columns={columns}
                checkboxSelection
                disableRowSelectionOnClick
                isRowSelectable={(params: GridRowParams) => params.row.isEditable}
                onRowSelectionModelChange={handleRowSelectionModel}
                rowSelectionModel={rowSelectionModel}
            />

            <TextField
                label="Remarks"
                multiline
                rows={1}
                value={remarks}
                variant="outlined"
                onChange={(e) => setRemarks(e.target.value)}
                sx={{ width: '1400px', marginTop: '25px' }}
            />

            <Stack width="100%" marginTop="25px" direction="row" justifyContent="flex-end" gap="10px" align-items="center">
                <Button onClick={onClose}>Cancel</Button>
                <Button color="primary" variant="contained" disabled={ !destinationID } onClick={handleSubmit}>Submit</Button>
            </Stack>
        </Container>
    )
}

export default CreateStockModal